import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    exchangeSession(sessionId)
      .then((user) => {
        // Clear the hash and land on the inbox.
        window.history.replaceState({}, document.title, "/admin/enquiries");
        navigate("/admin/enquiries", { replace: true, state: { user } });
      })
      .catch((err) => {
        setError(err.message || "We could not complete your sign-in. Please try again.");
      });
  }, [exchangeSession, location.hash, navigate]);

  return (
    <main className="admin-shell" data-testid="auth-callback">
      <div className="admin-loader">
        {error ? (
          <>
            <h2>Sign-in blocked</h2>
            <p>{error}</p>
            <a href="/admin/login" className="literature-btn" data-testid="auth-callback-back">
              Back to sign in
            </a>
          </>
        ) : (
          <>
            <Loader2 className="spin" size={26} />
            <p>Signing you in…</p>
          </>
        )}
      </div>
    </main>
  );
}
